export default {
  setVehicleDetails(state, { vehicle }) {
    state.vehicle = vehicle
  },
  reset(state) {
    state.vehicle = null
  },
}
